document.querySelectorAll('.qty').forEach(q=>{
  if(q.closest('.cartwrap'))return; // the cart handles its own quantity via AJAX below
  const s=q.querySelector('span');let n=parseInt(s.textContent)||1;const qi=q.querySelector('.qty-input');
  q.querySelectorAll('button').forEach((b,i)=>b.onclick=()=>{n=Math.max(1,n+(i?1:-1));s.textContent=n;if(qi)qi.value=n;});
});
// Cart page: update quantities + remove items via Shopify's Cart AJAX API
(function(){
  var wrap=document.querySelector('.cartwrap');if(!wrap)return;
  var busy=false;
  var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)?window.Shopify.routes.root:'/';
  function change(line,qty){
    if(busy)return;busy=true;wrap.style.opacity='.55';wrap.style.pointerEvents='none';
    fetch(base+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:line,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(){window.location.reload();})
      .catch(function(){busy=false;wrap.style.opacity='';wrap.style.pointerEvents='';alert('Sorry, we could not update your cart. Please try again.');});
  }
  wrap.addEventListener('click',function(e){
    var rem=e.target.closest('.lp-remove');
    if(rem){change(parseInt(rem.dataset.line,10),0);return;}
    var qbox=e.target.closest('.qty');if(!qbox)return;
    var line=parseInt(qbox.dataset.line,10);
    var cur=parseInt(qbox.querySelector('span').textContent,10)||1;
    if(e.target.closest('.qplus'))change(line,cur+1);
    else if(e.target.closest('.qminus'))change(line,Math.max(0,cur-1));
  });
})();
document.querySelectorAll('.chips').forEach(g=>g.querySelectorAll('.chip').forEach(c=>c.onclick=()=>{
  g.querySelectorAll('.chip').forEach(x=>x.classList.remove('sel'));c.classList.add('sel');}));
document.querySelectorAll('.swatch').forEach(s=>s.onclick=()=>{
  s.parentNode.querySelectorAll('.swatch').forEach(x=>x.classList.remove('sel'));s.classList.add('sel');});
document.querySelectorAll('.gallery .thumbs .t').forEach(t=>t.onclick=()=>{
  document.querySelectorAll('.gallery .thumbs .t').forEach(x=>x.classList.remove('sel'));t.classList.add('sel');
  const im=t.querySelector('img');const main=document.getElementById('pmain');if(im&&main&&im.dataset.full)main.src=im.dataset.full;});
document.addEventListener('click',function(e){var bg=e.target.closest('.burger');if(bg){e.preventDefault();var nv=document.querySelector('.mobile-nav');if(nv){var op=nv.classList.toggle('open');if(op){var bar=document.querySelector('.header .wrap');if(bar){nv.style.setProperty('--mnav-top',Math.round(bar.getBoundingClientRect().bottom)+'px');}}bg.setAttribute('aria-expanded',op);}return;}if(e.target.closest('.mobile-nav a')){var mn=document.querySelector('.mobile-nav');if(mn)mn.classList.remove('open');}});
document.querySelectorAll('.bene').forEach(el=>{
  el.addEventListener('click',e=>{e.stopPropagation();const was=el.classList.contains('open');
    document.querySelectorAll('.bene.open').forEach(x=>x.classList.remove('open'));if(!was)el.classList.add('open');});
  el.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();el.click();}});
});
document.addEventListener('click',()=>document.querySelectorAll('.bene.open').forEach(x=>x.classList.remove('open')));
// sticky header shadow once the announcement bar has scrolled past
(function(){var h=document.querySelector('.header');if(!h)return;var onScroll=function(){h.classList.toggle('scrolled',window.scrollY>4);};onScroll();window.addEventListener('scroll',onScroll,{passive:true});})();

// head search expand
(function(){
  var root=document.querySelector('[data-head-search]');
  if(!root) return;
  var toggle=root.querySelector('.head-search-toggle');
  var panel=root.querySelector('.head-search-panel');
  var input=root.querySelector('#head-search-input');
  var closeBtn=root.querySelector('.head-search-close');
  var header=document.querySelector('.header');
  function setTop(){
    if(!header) return;
    var bottom=Math.round(header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--head-search-top', bottom+'px');
  }
  function open(){
    setTop();
    root.classList.add('is-open');
    panel.hidden=false;
    toggle.setAttribute('aria-expanded','true');
    // close mobile nav if open so search isn't buried
    var mn=document.querySelector('.mobile-nav');
    if(mn) mn.classList.remove('open');
    var bg=document.querySelector('.burger');
    if(bg) bg.setAttribute('aria-expanded','false');
    requestAnimationFrame(function(){ try{ input.focus(); input.select(); }catch(e){} });
  }
  function close(){
    root.classList.remove('is-open');
    panel.hidden=true;
    toggle.setAttribute('aria-expanded','false');
  }
  function isOpen(){ return root.classList.contains('is-open'); }
  toggle.addEventListener('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    if(isOpen()) close(); else open();
  });
  if(closeBtn) closeBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); close(); toggle.focus(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && isOpen()){ close(); toggle.focus(); } });
  document.addEventListener('click', function(e){
    if(!isOpen()) return;
    if(e.target.closest('[data-head-search]')) return;
    // allow clicks inside fixed mobile panel (still inside root)
    close();
  });
  window.addEventListener('resize', function(){ if(isOpen()) setTop(); }, {passive:true});
  window.addEventListener('scroll', function(){ if(isOpen()) setTop(); }, {passive:true});
})();
// end head search
